module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact-form"
    }
  }, [_c('div', {
    staticClass: "form-wrapper",
    on: {
      "change": _vm.setDirty,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('first_name')
    }
  }, [_c('label', {
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("Nome")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.first_name),
      expression: "contact.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-first-name",
      "name": "first_name",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "first_name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('first_name')),
      expression: "errors.has('first_name')"
    }],
    key: "first_name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('first_name')))])])], 1)]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('last_name')
    }
  }, [_c('label', {
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("Sobrenome")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.last_name),
      expression: "contact.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-last-name",
      "name": "last_name",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "last_name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('last_name')),
      expression: "errors.has('last_name')"
    }],
    key: "last_name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('last_name')))])])], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("URL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.url),
      expression: "contact.url"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-url",
      "name": "url",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "url", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LinkedIn")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.linkedin),
      expression: "contact.linkedin"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "linkedin",
      "name": "linkedin",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.linkedin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "linkedin", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.business_class
  }, [_c('label', {
    attrs: {
      "for": "business"
    }
  }, [_vm._v("Empresa")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.business.name),
      expression: "contact.business.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-business",
      "name": "business",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.business.name)
    },
    on: {
      "blur": _vm.updated_base_business,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact.business, "name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.business_help_text),
      expression: "business_help_text"
    }],
    key: "business",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.business_help_text))])])], 1)]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "position"
    }
  }, [_vm._v("Cargo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.position),
      expression: "contact.position"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-position",
      "name": "position",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "position", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('telephone')
    }
  }, [_c('label', {
    attrs: {
      "for": "telephone"
    }
  }, [_vm._v("Telefone")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.telephone),
      expression: "contact.telephone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-telephone",
      "name": "telephone",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "telephone", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('telephone')),
      expression: "errors.has('telephone')"
    }],
    key: "telephone",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('telephone')))])])], 1)]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('cellphone')
    }
  }, [_c('label', {
    attrs: {
      "for": "cellphone"
    }
  }, [_vm._v("Celular")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.cellphone),
      expression: "contact.cellphone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-cellphone",
      "name": "cellphone",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "cellphone", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cellphone')),
      expression: "errors.has('cellphone')"
    }],
    key: "cellphone",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('cellphone')))])])], 1)]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Endereço")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.address),
      expression: "contact.address"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "user-address",
      "name": "address",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "address", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Variável 1")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.variable1),
      expression: "contact.variable1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "variable-1",
      "name": "variable1",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.variable1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "variable1", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Variável 2")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.variable2),
      expression: "contact.variable2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "variable-2",
      "name": "variable2",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.variable2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "variable2", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Variável 3")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.variable3),
      expression: "contact.variable3"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "variable-2",
      "name": "variable3",
      "type": "text",
      "disabled": _vm.user_is_monitoring_manager
    },
    domProps: {
      "value": (_vm.contact.variable3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "variable3", $event.target.value)
      }
    }
  })])]), _vm._l((_vm.contact.contact_custom_fields), function(contact_custom_field, index) {
    return _c('div', {
      key: contact_custom_field.field,
      class: _vm.customFieldColumnClass(index)
    }, [_c('div', {
      staticClass: "form-group",
      class: {
        'has-error': _vm.errors.has('custom_field_' + contact_custom_field.id)
      }
    }, [_c('label', {
      attrs: {
        "for": contact_custom_field.field
      }
    }, [_vm._v(_vm._s(contact_custom_field.field))]), (contact_custom_field.kind == 'dropdown') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact_custom_field.value),
        expression: "contact_custom_field.value"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.user_is_monitoring_manager
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(contact_custom_field, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((contact_custom_field.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option.name
        }
      }, [_vm._v(_vm._s(option.name))])
    }), 0) : (contact_custom_field.kind != 'textarea') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact_custom_field.value),
        expression: "contact_custom_field.value"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: (_vm.custom_field_mask(contact_custom_field)),
        expression: "custom_field_mask(contact_custom_field)"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": _vm.user_is_monitoring_manager
      },
      domProps: {
        "value": (contact_custom_field.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact_custom_field, "value", $event.target.value)
        }
      }
    }) : _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contact_custom_field.value),
        expression: "contact_custom_field.value"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: (_vm.custom_field_mask(contact_custom_field)),
        expression: "custom_field_mask(contact_custom_field)"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.user_is_monitoring_manager
      },
      domProps: {
        "value": (contact_custom_field.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contact_custom_field, "value", $event.target.value)
        }
      }
    }), _c('transition-group', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('custom_field_' + contact_custom_field.id)),
        expression: "errors.has('custom_field_' + contact_custom_field.id)"
      }],
      key: "first_name",
      staticClass: "help-block"
    }, [_vm._v(_vm._s(_vm.errors.first('custom_field_' + contact_custom_field.id)))])])], 1)])
  })], 2)]), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.submittable
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Salvar")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ef221b8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/form.vue
// module id = 1179
// module chunks = 1